/*
 * @Author: ningbo.kang
 * @Date: 2019-10-18 09:30:49
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-11-02 16:47:53
 * @Description:
 */
// import e2Ellipsis from 'e2-ellipsis';
import e2Container from './e2-container';
// import e2Table from './e2-table';
import e2Svg from './e2-svg/index.vue';

import E2Breadcrumb from './tools/Breadcrumb.vue';

export default {
  install(Vue) {
    // 注意 有些组件使用异步加载会有影响
    Vue.component(e2Container.name, e2Container);
    // Vue.component(e2Table.name, e2Table);
    Vue.component(e2Svg.name, e2Svg);
    // Vue.component(e2Ellipsis.name, e2Ellipsis);
    Vue.component(E2Breadcrumb.name, E2Breadcrumb);
  }
};
